export const costs = [
  'Sleepless nights searching for ways to translate complex atmospheric processes into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how meteorology connects to weather hazards, climate, or their communities.",
  "Awkward silences when a student asks how tornadoes form or why hurricanes occur and you don't have a clear answer.",
  'Weekends lost building lesson plans, weather analysis projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach severe weather, forecasting, or climate systems without adequate resources.',
];
